<template>
    <div>
        <div
            :class="[
        { 'col-md-4': vertical && !tabNavWrapperClasses },
        { 'col-12': centered && !tabNavWrapperClasses },
        tabNavWrapperClasses
      ]"
        >
            <ul
                class="nav nav-pills"
                role="tablist"
                :class="[
          `nav-pills-${type}`,
          { 'flex-column': vertical },
          { 'justify-content-center': centered },
          tabNavClasses
        ]"
            >
                <li
                    v-for="tab in tabs"
                    class="nav-item active"
                    data-toggle="tab"
                    role="tablist"
                    aria-expanded="true"
                    :key="tab.id"
                >
                    <a
                        data-toggle="tab"
                        role="tablist"
                        :href="`#${tab.id}`"
                        @click.prevent="activateTab(tab)"
                        :aria-expanded="tab.active"
                        class="nav-link reset-padding"
                        :style="tab.active ? [$bgColor(color.primary), { color: color.secondary }] : { color: color.primary }"
                    >
                        <tab-item-content :tab="tab"></tab-item-content>
                    </a>
                </li>
            </ul>
        </div>
        <div
            class="tab-content"
            :class="[
        { 'tab-space': !vertical },
        { 'col-md-8': vertical && !tabContentClasses },
        tabContentClasses
      ]"
        >
            <slot></slot>
        </div>
    </div>
</template>

<script>
import { h } from 'vue';

export default {
    name: "tabs",
    components: {
        TabItemContent: {
            props: ["tab"],
            render() {
                let titleContent = this.tab.$slots.title;
                if (typeof titleContent === 'function') {
                    titleContent = titleContent();
                }
                return h("div", [titleContent || this.tab.title]);
            }
        }
    },
    provide() {
        return {
            addTab: this.addTab,
            removeTab: this.removeTab
        };
    },
    props: {
        type: {
            type: String,
            default: "info",
            validator: value => {
                let acceptedValues = [
                    "primary",
                    "info",
                    "success",
                    "warning",
                    "danger"
                ];
                return acceptedValues.indexOf(value) !== -1;
            }
        },
        firstOpenTab: {
            type: String,
            default: "",
            description: "First open tab"
        },
        activeTab: {
            type: String,
            default: "",
            description: "Active tab name"
        },
        tabNavWrapperClasses: {
            type: [String, Object],
            default: "",
            description: "ul wrapper css classes"
        },
        tabNavClasses: {
            type: [String, Object],
            default: "",
            description: "ul css classes"
        },
        tabContentClasses: {
            type: [String, Object],
            default: "",
            description: "tab content css classes"
        },
        vertical: Boolean,
        centered: Boolean,
        value: String
    },
    data() {
        return {
            tabs: []
        };
    },
    computed: {
        color() {
            return this.$store.getters.COLOR;
        },
        textColor() {
            return "";
        }
    },
    methods: {
        findAndActivateTab(title) {
            let tabToActivate = this.tabs.find(t => t.title === title);
            if (tabToActivate) {
                this.activateTab(tabToActivate);
            }
        },
        activateTab(tab) {
            this.$emit("selectedTab", tab.$el.id);
            if (this.handleClick) {
                this.handleClick(tab);
            }
            this.deactivateTabs();
            tab.active = true;
        },
        deactivateTabs() {
            this.tabs.forEach(tab => {
                tab.active = false;
            });
        },
        addTab(tab) {
            if (this.tabs.indexOf(tab) === -1) {
                this.tabs.push(tab);
            }
            if (this.activeTab && (this.activeTab === tab.title || this.activeTab === tab.id)) {
                this.deactivateTabs();
                tab.active = true;
            } else if (!this.activeTab && this.tabs.length === 1) {
                tab.active = true;
            }
        },
        removeTab(tab) {
            const tabs = this.tabs;
            const index = tabs.indexOf(tab);
            if (index > -1) {
                tabs.splice(index, 1);
            }
        }
    },
    mounted() {
        if (this.firstOpenTab) {
            this.findAndActivateTab(this.firstOpenTab);
        }
        this.$nextTick(() => {
            if (this.value) {
                this.findAndActivateTab(this.value);
            }
        });
    },
    watch: {
        value(newVal) {
            this.findAndActivateTab(newVal);
        }
    }
};
</script>

<style scoped>
.reset-padding {
    padding: 0 !important;
}
</style>
